import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Modal from '../common/Modal';
import Button from '../common/Button';
import Logout from '../common/Logout';
import UrlsList from './UrlsList';
import UserEdit from './edit';
import { requestDataIfNeeded } from './duck';

class MainInfo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      enableEditMode: false,
      selectedFile: null,
      loaded: 0,
    };
  }

  handleSuccess = () => {
    this.setState({ enableEditMode: false });
    this.props.requestUserDataIfNeeded();
  };

  closeModal = () => {
    this.setState({ enableEditMode: false });
  };

  openModal = () => {
    this.setState({ enableEditMode: true });
  };

  handleselectedFile = (event) => {
    this.setState({
      selectedFile: event.target.files[0],
      loaded: 0,
    });
  };

  render() {
    const { user, isCurrentUser, t } = this.props;
    const { enableEditMode } = this.state;

    return (
      <React.Fragment>
        <div className="o-media u-margin-bottom-huge">
          <img
            className="o-media__img u-img-round u-margin-bottom-tiny"
            width="115"
            height="115"
            src={user.getBigAvatarUrl()}
            alt="User Avatar"
          />

          <div className="o-media__body">
            <h2 className="u-margin-bottom-mini">
              {user.name}

              {isCurrentUser && (
                <div style={{ float: 'right' }}>
                  <Logout />
                </div>
              )}
            </h2>
            <UrlsList urls={user.urls} className="u-margin-bottom-tiny" />

            {isCurrentUser && (
              <Button styleType="edit" onClick={this.openModal}>
                {t('user.editProfile')}
              </Button>
            )}
          </div>
        </div>
        <Modal
          isOpen={enableEditMode}
          onRequestClose={this.closeModal}
          title={t('user.editProfileTitle')}
        >
          <UserEdit onSuccess={this.handleSuccess} user={user} />
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ user: currentUser }, { user }) => ({
  user: user,
  isCurrentUser: currentUser.data._id === user._id,
});

const mapDispatchToProps = { requestUserDataIfNeeded: requestDataIfNeeded };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate()(MainInfo));



// WEBPACK FOOTER //
// ./src/user/MainInfo.js